// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"013802d4","647":"f2aca424"}[chunkId] + ".chunk.js";
};